import { HeartHandshake } from "lucide-react";
import { Card, Section } from "../Layout";
import { useI18n } from "../i18n";

export default function Faith() {
  const { t } = useI18n();

  return (
    <Section
      id="faith"
      eyebrow={t("faith.eyebrow")}
      title={t("faith.title")}
      icon={HeartHandshake}
    >
      <Card className="p-6 sm:p-8 text-center">
        <blockquote className="mx-auto max-w-3xl font-serif text-2xl sm:text-3xl leading-tight text-theme-text">
          “{t("faith.verse")}”
        </blockquote>
        <p className="mt-4 text-xs uppercase tracking-[0.3em] text-theme-text-subtle">
          {t("faith.reference")}
        </p>
        <p className="mx-auto mt-6 max-w-2xl text-sm sm:text-base leading-relaxed text-theme-text-muted">
          {t("faith.text")}
        </p>
      </Card>
    </Section>
  );
}
